import React from 'react';
import ReactDOM from 'react-dom/client';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';

import { App } from './App';

import 'animate.css';
import '@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css';
// import './assets/styles/themes/angular/angular.scss';
import './assets/styles/themes/react/react.scss';
// import './assets/styles/themes/vue/vue.scss';

// import './assets/fontawesome/css/fontawesome.css';
// import './assets/fontawesome/css/light.css';
// import './assets/fontawesome/css/solid.css';
// import './assets/fontawesome/css/regular.css';
// import './assets/fontawesome/css/duotone.css';

import './assets/fontawesome/js/fontawesome.js';
import './assets/fontawesome/js/light.js';
import './assets/fontawesome/js/solid.js';
import './assets/fontawesome/js/regular.js';
import './assets/fontawesome/js/duotone.js';

TimeAgo.addDefaultLocale(en);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
